import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { VolabyCard } from '../../../../../common/cards/VolabyCard';
import { ActivityTypeSelection } from '../ActivityFormV2';

interface ActivityTypeCardProps {
  type: ActivityTypeSelection;
  icon: React.ReactNode;
  title: string;
  description: string;
  example: string;
  selected: boolean;
  onSelect: (type: ActivityTypeSelection) => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    optionHeading: {
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '20px',
      marginBottom: '8px',
      color: '#333',
    },
    optionDesc: {
      fontSize: '12px',
      fontWeight: 400,
      color: '#808080',
      lineHeight: 1.6,
    },
    optionExample: {
      fontSize: '11px',
      color: '#b0b0b0',
      fontStyle: 'italic',
      paddingTop: '12px',
    },
  })
);

export const ActivityTypeCard = ({
  type,
  icon,
  title,
  description,
  example,
  selected,
  onSelect,
}: ActivityTypeCardProps) => {
  const classes = useStyles();

  return (
    <VolabyCard color='#2FC0F9' bgColor='#f9f9f9' selected={selected} onClick={() => onSelect(type)}>
      <Box display='flex' flexDirection='column' alignItems='center' textAlign='center' px={2.5} py={3}>
        <Box style={{ marginBottom: 12, color: '#616161', fontSize: 32 }}>{icon}</Box>
        <Typography className={classes.optionHeading} align='center'>
          {title}
        </Typography>
        <Typography className={classes.optionDesc} align='center'>
          {description}
        </Typography>
        <Typography className={classes.optionExample} align='center'>
          {example}
        </Typography>
      </Box>
    </VolabyCard>
  );
};
